[data-mode="default"],
:host {
  --uui-btn-bg-color: var(--uui-theme-core-500);
  --uui-btn-width: auto;
  --uui-btn-color: var(--uui-theme-on-core-400);
  --uui-btn-hover-color: var(--uui-btn-color);
  --uui-btn-hover-bg-color: var(--uui-theme-core-400);

  --uui-btn-disabled-color: var(--uui-btn-color);
  --uui-btn-disabled-bg-color: var(--uui-btn-bg-color);
  --uui-btn-active-color: var(--uui-btn-color);
  --uui-btn-active-bg-color: var(--uui-theme-core-600);
  --uui-btn-icon-size: 1.3rem;
  --uui-btn-gap: var(--uui-medium-gap);
  --uui-btn-border-color: transparent;
  --uui-btn-hover-border-color: transparent;
  --uui-btn-active-border-color: transparent;
}

:host(.button-disabled) {
  pointer-events: none;
  cursor: not-allowed;
}

[data-mode="subtle"] {
  --uui-btn-border-color: var(--uui-theme-on-core-500);
  --uui-btn-hover-border-color: var(--uui-theme-on-core-500);
  --uui-btn-active-border-color: var(--uui-theme-on-core-500);
  --uui-btn-color: var(--uui-theme-on-core-500);
  --uui-btn-bg-color: none;
  --uui-btn-hover-color: var(--uui-theme-on-core-500);
  --uui-btn-hover-bg-color: var(--uui-theme-on-core-900);
  --uui-btn-disabled-bg-color: var(--uui-btn-bg-color);
  --uui-btn-disabled-color: var(--uui-btn-color);
  --uui-btn-active-bg-color: var(--uui-theme-variant-800);
  --uui-btn-active-color: var(--uui-theme-on-core-500);
}

[data-mode="prominent"] {
  --uui-btn-bg-color: var(--uui-theme-on-core-500);
  --uui-btn-disabled-bg-color: var(--uui-btn-bg-color);
  --uui-btn-color: var(--uui-theme-on-secondary-800);
  --uui-btn-hover-color: var(--uui-theme-on-secondary-700);
  --uui-btn-hover-bg-color: var(--uui-theme-secondary-400);
  --uui-btn-disabled-color: var(--uui-btn-color);
  --uui-btn-disabled-bg-color: var(--uui-btn-bg-color);
  --uui-btn-active-bg-color: var(--uui-theme-tertiary-900);
  --uui-btn-active-color: var(--uui-theme-on-secondary-900);
}

[data-mode="ghost"], [data-mode="text"] {
  --uui-btn-color: var(--uui-theme-core-500);
  --uui-btn-disabled-color: var(--uui-btn-color);
  --uui-btn-bg-color: none;
  --uui-btn-disabled-bg-color: var(--uui-btn-bg-color);
  --uui-btn-hover-color: var(--uui-theme-core-400);
  --uui-btn-hover-bg-color: none;
  --uui-btn-disabled-bg-color: var(--uui-btn-bg-color);
  padding-left: 0;
  padding-right: 0;
  --uui-btn-active-color: var(--uui-theme-core-600);
  --uui-btn-active-bg-color: none;
}

[data-mode="icon"] {
  --uui-btn-color: var(--uui-theme-core-500);
  --uui-btn-bg-color: none;
  --uui-btn-hover-color: var(--uui-theme-core-400);
  --uui-btn-hover-bg-color: var(--uui-theme-background-100); 
  --uui-btn-active-color: var(--uui-theme-core-600);
  --uui-btn-active-bg-color: var(--uui-theme-background-200);
  --uui-border-radius: 50%;
  --uui-btn-disabled-bg-color: none;
  --uui-btn-disabled-color: var(--uui-theme-core-500);
}

button {
  font-weight: var(--uui-font-weight-normal);
  font-size: var(--uui-default-font-size);
  line-height: 1.25rem;
  min-width: 8.125rem;
  width: var(--uui-btn-width);
  padding: 0.6875rem;
  padding-inline-start: var(--uui-medium-padding);
  padding-inline-end: var(--uui-medium-padding);
  border-radius: var(--uui-border-radius);
  border-style: solid;
  display: inline-flex;
  gap: var(--uui-btn-gap);
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-color: var(--uui-btn-border-color);
  outline: none;
  background-color: var(--uui-btn-bg-color);
  color: var(--uui-btn-color);
  fill: var(--uui-btn-color);
  font-family: var(--uui-primary-font-family);
}

button:focus-visible {
  outline: auto;
}

button:disabled {
  opacity: var(--uui-disabled-opacity);
  color: var(--uui-btn-disabled-color);
  fill: var(--uui-btn-disabled-color);
  background-color: var(--uui-btn-disabled-bg-color);
}

button:enabled:hover {
  cursor: pointer;
  text-decoration: var(--uui-btn-hover-text-decoration);
  background-color: var(--uui-btn-hover-bg-color);
  color: var(--uui-btn-hover-color);
  fill: var(--uui-btn-hover-color);
  border-color: var(--uui-btn-hover-border-color);
}

button:enabled:active,
:host([active]:not([active="false"])) button:enabled[data-mode="icon"] {
  text-decoration: underline;
  color: var(--uui-btn-active-color);
  fill: var(--uui-btn-active-color);
  background-color: var(--uui-btn-active-bg-color);
  border-color: var(--uui-btn-active-border-color);
}

button[data-mode="ghost"], button[data-mode="text"] {
  text-decoration: underline;
  min-width: 0;
}

button[data-mode="ghost"]:enabled:hover,
button[data-mode="ghost"]:enabled:active,
button[data-mode="text"]:enabled:hover,
button[data-mode="text"]:enabled:active  {
  text-decoration: none;
}

button[data-mode="icon"] {
  min-width: 2.75rem;
  width: 2.75rem;
  height: 2.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

button[data-mode="icon"]:hover {
  text-decoration: none;
}


slot[name="icon"]::slotted(uui-icon) { 
  color: var(--uui-btn-color);
  font-size: var(--uui-btn-icon-size);
} 


